// converts given number to local string (with commas, spaces and dot)
import { getInitialProps } from 'react-i18next';

export const convertToLocale = (num: number) => {
  const {initialLanguage} = getInitialProps();
  return num.toLocaleString(initialLanguage);
};
